import { render, staticRenderFns } from "./Fabricacion.vue?vue&type=template&id=6cb35e85&"
import script from "./Fabricacion.vue?vue&type=script&lang=js&"
export * from "./Fabricacion.vue?vue&type=script&lang=js&"
import style0 from "./Fabricacion.vue?vue&type=style&index=0&id=6cb35e85&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports